// tslint:disable-next-line:no-internal-module
// tslint:disable-next-line:no-namespace
module ProcessList {
    "use strict";
    import IFrendsResult = Shared.IFrendsResult;

    export class ProcessDataService {
        public static $inject = ["$http"];
        constructor(private $http: ng.IHttpService) {
        }

        public getProcesses(query: IProcessListQuery): ng.IPromise<IFrendsResult<IProcessListData>> {
            return this.$http.get("Process/GetProcessList", { params: query })
                .then((response) => response.data);
        }

        public getProcessCounts(timelimit?: number): ng.IPromise<IFrendsResult<IProcessExecutionCountEventData>> {
            return this.$http.get("Process/GetProcessCounts", { params: { timelimitDays: timelimit } })
                .then((response) => response.data);
        }

        public deployProcesses(processesWithVersions: IProcessWithVersionToDeploy[], environmentName: string, agentGroupName: string, isSwitchVersion: boolean, activateTriggers: boolean): ng.IPromise<IFrendsResult<string>> {
            const processVersions = processesWithVersions.map((pv) => ({
                processGuid: pv.uniqueIdentifier,
                version: pv.versionToDeploy
            }));
            const postData = { processVersions: processVersions, environmentName: environmentName, agentGroupName: agentGroupName, isSwitchVersion: isSwitchVersion, activateTriggers: activateTriggers };
            return this.$http.post("Process/DeployProcesses", postData)
                .then((response) => response.data);
        }

        public deleteProcesses(processIds: number[], environmentName: string, agentGroupName: string): ng.IPromise<IFrendsResult<string>> {
            return this.$http.post("Process/Delete", { id: processIds, environmentName: environmentName, agentGroupName: agentGroupName })
                .then((response) => response.data);
        }

        public genericBatchAction(postData, actionUri, disableSpinner: boolean = false): ng.IPromise<IFrendsResult<string>> {
            return this.$http.post(actionUri, postData, { disableSpinner }).then((response) => response.data);
        }

        public getAllUsedTags(): ng.IPromise<IFrendsResult<string[]>> {
            return this.$http.get("Tags/GetUsedTags")
                .then((response) => response.data);
        }

        public saveTags(processIds, tags, saveType): ng.IPromise<IFrendsResult<string>> {
            return this.$http.post("Process/Tag", { processIds: processIds, tagString: tags, tagAddType: saveType })
                .then((response) => response.data);
        }

        public discardDraft(processId): ng.IPromise<IFrendsResult<string>> {
            return this.$http.post("Process/DiscardDraft", { id: processId })
                .then((response) => response.data);
        }

        public getLogSettings(environmentName: string, processGuid?: string): ng.IPromise<IFrendsResult<ILogSettingData>> {
            return this.$http.get("Process/GetLogSettings", { params: { processGuid: processGuid, environmentName: environmentName } })
                .then((response) => response.data);
        }
    }

    module.service("ProcessDataService", ProcessDataService);

    export interface IProcessListQuery {
        environmentName: string;
        agentGroupName: string;
        timeLimit: number;
        filterString?: string;
        page?: number;
        tag?: string;
    }

    export interface IProcessWithVersionToDeploy extends IProcessData {
        versionToDeploy: number;
    }

    export interface ITriggerData {
        type: string;
        name: string;
        description: string;
        initializationException: string;
    }

    export interface ILogSettingData {
        logLevel: string;
        historyStorageDays: number;
        logTriggerRequestAndResponse: boolean;
    }

    export interface IProcessListData {
        processList: IProcessData[];
        draftList: IDraftData[];
    }

    export interface IProcessData {
        name: string;
        id: number;
        uniqueIdentifier: string;
        version: number;
        description?: string;
        tagString: string;
        majorVersion: number;
        usedTasks: IUsedTaskData[];
        minorVersion: number;
        existingVersions: IExistingVersions[];
        triggersUsed: ITriggerData[];
        manualTriggerParameters: any[];
        triggersActive: boolean;
    }
    export interface IUsedTaskData {
        name: string;
        uri: string;
        fullName: string;
        packageName: string;
    }

    export interface IDraftData {
        name: string;
        id: number;
        modified: string;
        modifier: string;
        processId?: number;
    }

    export interface IDeployedVersionData {
        versionNumber: number;
        environmentName: string;
    }
    export interface IExistingVersions {
        majorVersion: number;
        minorVersion: number;
        versions: number[];
        deployedProcessVersions: IDeployedVersionData[];
        changeDescriptions: IChangeDescriptionByVersion[];
    }

    export interface IChangeDescriptionByVersion {
        versionNumber: number;
        changeDescription: string;
    }

    export interface IProcessExecutionCountEventData {
        isFullRefresh: boolean;
        executionCounts: IProcessExecutionCountData;
    }

    export interface IProcessExecutionCount {
        running?: number;
        latestRunning?: string;
        successful?: number;
        latestSuccessful?: string;
        failed?: number;
        latestFailed?: string;
        erroredNotAcknowledged?: number;
        latestExecutionState?: string;
        latestExecutionStartTime?: string; // not set on data from backend
        total?: number; // not set on data from backend
    }

    export interface IProcessExecutionCountData {
        [environment: string]: {
            [processGuid: string]: {
                [date: string]: IProcessExecutionCount
            }
        }
    }

    export interface IGroupedProcessExecutionCounts {
        [processGuid: string]: IProcessExecutionCount
    }
}
